export default {
  AccessibilityAccommodationsFormFields__COGNITIVE_DISABILITY:
    "Cognitive and developmental disabilities",
  AccessibilityAccommodationsFormFields__HEADER: "Accessibility accommodations",
  AccessibilityAccommodationsFormFields__HEARING_DISABILITY: "Deaf or hard of hearing",
  AccessibilityAccommodationsFormFields__VISION_DISABILITY: "Blind or have low vision",
};
